import type { LucideIcon } from 'lucide-react'
import {
  Bell,
  CreditCard,
  Crosshair,
  Crown,
  Binoculars,
  Headphones,
  LayoutDashboard,
  Package,
  Radar,
  Sparkles,
  Store,
} from 'lucide-react'

export type DashboardNavItem = {
  label: string
  path: string
  icon?: LucideIcon
  description?: string
  badge?: string
  requireStaff?: boolean
  requireKmpAdmin?: boolean
  requireOrgAdmin?: boolean
  requireCopilot?: boolean
  requireCategoryTree?: boolean
  placement?: 'primary' | 'secondary'
}

export const dashboardNavItems: DashboardNavItem[] = [
  {
    label: 'Огляд',
    path: 'dashboard',
    icon: LayoutDashboard,
    description: 'Стан магазину, сигнали й наступні дії',
  },
  {
    label: 'Магазини',
    path: 'stores/config',
    icon: Store,
    description: 'Підключення marketplace-акаунтів',
    requireOrgAdmin: true,
  },
  {
    label: 'Товари',
    path: 'products',
    icon: Package,
    description: 'Власні товари підключених магазинів',
  },
  {
    label: 'Скаутер',
    path: 'categories',
    icon: Binoculars,
    description: 'Категорії маркетплейсів і товари з останнього збору',
    requireCategoryTree: true,
  },
  {
    label: 'Пошукова видача',
    path: 'product-visibility',
    icon: Radar,
    description: 'Позиції товарів, ключі й AI-рекомендації',
  },
  {
    label: 'Конкуренти',
    path: 'competitors',
    icon: Crosshair,
    description: 'Товари конкурентів, ціни й швидкий аналіз позицій',
  },
  {
    label: 'AI-Помічник',
    path: 'copilot',
    icon: Sparkles,
    description: 'Розмова з вашими ринковими й власними даними',
    requireCopilot: true,
  },
  {
    label: 'King of Marketplaces',
    path: 'king-of-marketplaces',
    icon: Crown,
    requireKmpAdmin: true,
  },
  {
    label: 'Сповіщення',
    path: 'notifications',
    icon: Bell,
    description: 'Канали, правила й ранкові огляди',
    placement: 'secondary',
  },
  {
    label: 'Допомога',
    path: 'help',
    icon: Headphones,
    description: 'Канали підтримки, FAQ та відеоуроки',
    placement: 'secondary',
  },
  {
    label: 'Підписка',
    path: 'billing',
    icon: CreditCard,
    description: 'План, доступ і білінг',
    placement: 'secondary',
    requireOrgAdmin: true,
  },
]
